import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "collapseTrigger",
    "expandTrigger"
  ]

  static outlets = [
    "components--expandable"
  ]

  static values = {
    isOpen: { type: Boolean, default: false }
  }

  connect() {
    this.#adjustUI()
  }

  disconnect() {
    this.componentsExpandableOutlets.forEach((outlet) => {
      outlet.unregisterManager()
    })
  }

  componentsExpandableOutletConnected(outlet, _element) {
    outlet.registerManager(this)
  }

  componentsExpandableOutletDisonnected(outlet, _element) {
    outlet.unregisterManager()
  }

  /**
   * childUpdated()
   *
   * callback from any managed expandable
   *
   * checks to see if all the children are in an agreeable state and updates this
   * controller's state if so.
   */
  childUpdated() {
    const outlets = this.componentsExpandableOutlets
    let consensusState = outlets[0].isOpen
    for (let i = 1; i < outlets.length; i++) {
      if (consensusState !== outlets[i].isOpen) {
        consensusState = undefined
        break
      }
    }
    if (consensusState !== undefined) {
      this.isOpenValue = consensusState
    } else {
      this.isOpenValue = true
    }
    this.#adjustUI()
  }

  toggle() {
    this.isOpenValue = !this.isOpenValue
    this.#adjustUI()
    this.componentsExpandableOutlets.forEach(expandable => {
      expandable.set(this.isOpenValue)
    })
  }

  #adjustUI() {
    if (this.hasCollapseTriggerTarget) {
      this.collapseTriggerTarget.classList.toggle("hidden", !this.isOpenValue)
    }

    if (this.hasExpandTriggerTarget) {
      this.expandTriggerTarget.classList.toggle("hidden", this.isOpenValue)
    }
  }
}
